import { z } from 'zod'

const optionalTrimmed = (max: number) => z.string().trim().max(max).optional().transform((value) => value || undefined)

export const ContactRequestSchema = z.object({
  name: z.string().trim().min(1, 'name is required').max(120),
  email: z.string().trim().email('email must be valid').max(254).transform((value) => value.toLowerCase()),
  message: z.string().trim().min(1, 'message is required').max(10_000),
  phone: optionalTrimmed(32).refine((value) => value === undefined || /^\+?\d{6,15}$/.test(value), 'phone must be valid'),
  vehicleReference: optionalTrimmed(160),
  privacyAccepted: z.boolean().optional().refine((value) => value !== false, 'privacy acknowledgement required'),
  lang: z.enum(['it', 'en']).default('it'),
})

export type ContactRequest = z.infer<typeof ContactRequestSchema>

export const ContactResponseSchema = z.object({
  success: z.literal(true),
  timestamp: z.string(),
})

export type ContactResponse = z.infer<typeof ContactResponseSchema>
